import IconListItem from './iconListItem';
import styles from './iconList.module.scss';

export default function IconList(props) {
  const { list } = props;
  return (
    <div className={styles.iconList}>
      {list.map((item) => {
        return (
          <IconListItem
            key={item.title}
            icon={item.icon}
            title={item.title}
            description={item.description}
          />
        );
      })}
    </div>
  );
}
